import React, { Component, createRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip'
import Datetime from 'react-datetime';
import '../../../../../node_modules/react-datetime/css/react-datetime.css'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import queryString from 'query-string';
import 'bootstrap-daterangepicker/daterangepicker.css';
import NotificationSystem from 'react-notification-system';
import ReactTable from 'react-table';
import '../../../../../src/assets/css/react-table.css'
import OrderCost from '../AdminReports/Orders/orderCost';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
import {
    _addNotification, _addNotificationError,
    formatDate, allowNumericWithdecimal, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, showFile,
    convertTwoDecimalPoint, getSessionStartEndDates, getModuleEnum, getAccessLevelByModule, getSchoolGrades, groupBy, numberParce, getSalesTaxStatus, getLastMonthStartEndDates
} from "../../../../server/util";
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
import { get, postWithHeaders, postWithHeadersResponse, _delete } from "../../../../server/actions";
import { currency_symbol } from '../../../../server/constants'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { BeatLoader } from 'react-spinners';
import $ from "jquery";
import AccountHistory from "../../PaymentReports/AccountHistory";
import LowBalReport from "../../PaymentReports/LowBalReport";
import moment from 'moment';
import Modal from 'react-modal'
import BcacPayments from '../../PaymentReports/bcacPayments';
import AdjustmentReport from './adjustmentReport';
import SalesReport from './sales';
import SalesTaxReport from './salesTaxReport';
import MonthlyIncomeCash from './monthlyIncomeCash';
import DonationPartnerReport from './donationPartnerReport';
import BulkPurchases from './bulkPurchases';
import StripeReconciliationreport from './stripeReconciliationreport';
import DailySalesReport from './dailySalesReport'
import ConsumptionPaymentReport from './ConsumptionPaymentReport';

var converter = require('number-to-words');
let download = require('downloadjs');
var _ = require('lodash');
const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '55%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    },
    customManageUsersStyles: {
        content: {
            top: '40%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            width: '30%',
            transform: 'translate(-50%, -50%)',
            overflow: 'initial'
        }
    }
};
const enumMealType = {
    lunch: 'Lunch',
    breakfast: 'Breakfast',
    milk: 'Milk',
    snack: 'Snack',
    dinner: 'Dinner'
}
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
const modEnum = getModuleEnum();
let gradeList = [];
var valid = function (current) {
    let maxDate = moment().add(2, 'months');
    if (current <= maxDate) {
        return current.day() !== 0 && current.day() !== 6;
    }
    else {
        return false;
    }

};


class ReportTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            transactionData: [],
            purchaseData: [],
            students: [],
            studentsCount: 0,
            data: [],
            columns: [],
            selection: [],
            selectAll: false,
            selectedRows: [],
            currentPage: 0,
            currentGrade: '0',
            displayRecId: '',
            tdataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            purchaseDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            eventPayDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            lowBalReport: [],
            mapKeyVal: {},
            modalIsOpen: false,
            accountHistStudentData: [],
            depositSummery: [],
            eventsPayments: [],
            tabSelect: '',
            lowBalFilter: {
                filter: 'DEFAULT',
                opr: 'E',
                amount: 0.00
            },
            selectedDates: {
                startDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).startOf('month'),
                endDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).endOf('month')
            },
            deletePurchaseModel: false,
            donationsReport: [],
            deletePurchaseId: 0,
            mealType: enumMealType.lunch,
            date: moment(),
            accountBalTabIndex: '',
            selectedReportType: 4,
            startDate: moment().startOf('month'),
            deleteDepRecId: 0,
            showDelDepModal: false,
        }
        const { reportName } = this.props.match.params
        this.renderInput = this.renderInput.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
        this.getDataByGrade = this.getDataByGrade.bind();
        this.previousPage = this.previousPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.getLowBalData = this.getLowBalData.bind(this);
        this.deletePurchaseRec = this.deletePurchaseRec.bind(this);
        this.bcacChild = React.createRef(this);
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} style={{ width: '25%' }} />
                <button type="button" className="input-group-addon" onClick={openCalendar} style={{ width: '8%' }}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }

    setDate = (selectedDate) => {
        this.setState({ date: selectedDate });
    }
    onChangeDateRange = (startDate, endDate) => {
        let _selectedDate = { startDate: startDate, endDate: endDate }
        this.setState({ selectedDates: _selectedDate },
            this.getData(startDate, endDate, false)
        );
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.state.activeMonth !== nextProps.activeMonth) {
            let _selectedDate = {
                startDate: moment((nextProps.activeMonth || moment()), 'YYYYMM').startOf('month'),
                endDate: moment((nextProps.activeMonth || moment()), 'YYYYMM').endOf('month')
            }
            this.setState({ selectedDates: _selectedDate }, this.getData(_selectedDate.startDate, _selectedDate.endDate, false))
        }
    }
    downloadPurchaseExcel = (startDate, endDate) => {
        const _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let dateStart = moment(startDate).startOf('D');
        let dateEnd = moment(endDate).endOf('D');
        this.setState({ loading: true });
        get('/reports/purchaseTransactions/' + userInfo.schoolId + '/' + sessionStorage.getItem('schoolYearValue') + '?startDate='
            + moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&endDate=' + moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&fileType=Excel' + '&access_token=').then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    // _addNotificationError(res.statusMessage,this)
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    return res.blob();
                }
            }).then(blob => {
                this.setState({ loading: false })
                let filename = 'Purchase_Report.Excel';
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    this.setState({ loading: false })
                }
            );

    }

    getData = (startDate, endDate, isPdf = false) => {
        const { reportName } = this.props.match.params
        console.log("Get Data of", reportName)
        let _self = this;
        let isDeposit = reportName === "Purchase" ? false : true
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let dateStart = moment(startDate).startOf('D');
        let dateEnd = moment(endDate).endOf('D');
        if (reportName === "Purchase") {
            this.setState({ loading: true });
            get('/reports/purchaseTransactions/' + userInfo.schoolId + '/' + sessionStorage.getItem('schoolYearValue') + '?' + 'startDate='
                + moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss") +
                '&endDate=' + moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss") + (isPdf ? '&fileType=pdf' : '') + '&access_token=').then((response) => {
                    if (!response.ok) {
                        if (response.status === 417) {
                            return response.json();
                        }
                    }
                    console.log('response', response);
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        throw Error(res.statusMessage);
                    } else if (!res.statusCode === 200) {
                        throw Error(res.errorMessage);
                    } else {
                        if (isPdf) {
                            return res.blob();
                        } else {
                            return res.json();
                        }
                    }
                }).then(data => {
                    if (isPdf) {
                        let filename = isDeposit ? 'Deposits_Report.pdf' : 'Purchase_Report.pdf';
                        showFile(data, filename);
                        this.setState({ loading: false });
                    } else {

                        this.setState({
                            purchaseData: data.resp, loading: false
                        })
                        this.forceUpdate()
                    }
                }).catch(
                    (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self)
                        this.setState({ loading: false })
                    }
                );

        } else if (reportName == "Deposit") {
            this.setState({ loading: true })
            get('/reports/transactionsReport?mealSchoolId=' + userInfo.schoolId + '&startDate='
                + moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss") +
                '&endDate=' + moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss") +
                '&isDeposit=' + isDeposit +
                '&schoolYear=' + sessionStorage.getItem('schoolYearValue') +
                '&fileExport=' + isPdf + '&access_token=').then((response) => {
                    if (!response.ok) {
                        if (response.status === 417) {
                            return response.json();
                        }
                    }
                    console.log('response', response);
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        throw Error(res.statusMessage);
                    } else if (!res.statusCode === 200) {
                        throw Error(res.errorMessage);
                    } else {
                        if (isPdf) {
                            return res.blob();
                        } else {
                            return res.json();
                        }
                    }
                }).then(data => {
                    if (isPdf) {
                        let filename = isDeposit ? 'Deposits_Report.pdf' : 'Purchase_Report.pdf';
                        showFile(data, filename);
                        this.setState({ loading: false });
                    } else {
                        if (isDeposit) {
                            this.setState({
                                transactionData: data.transactionReportsDetails, loading: false
                            })
                        }
                        else {
                            this.setState({
                                purchaseData: data.transactionReportsDetails, loading: false
                            })
                        }
                        this.forceUpdate()
                    }
                }).catch(
                    (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self)
                        this.setState({ loading: false })
                    }
                );
        } else if (reportName == "DepositSummary") {
            this.setState({ loading: true });
            get('/dashboard/balancePaymentTrend?mealSchoolId=' + userInfo.schoolId +
                '&startDate=' + moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss")
                + '&endDate=' + moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss") +
                '&schoolYear=' + sessionStorage.getItem('schoolYearValue') +
                '&fileExport=' + isPdf + '&access_token=').then((response) => {
                    if (!response.ok) {
                        if (response.status === 417) {
                            return response.json();
                        }
                    }
                    console.log('response', response);
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        throw Error(res.statusMessage);
                    } else if (!res.statusCode === 200) {
                        throw Error(res.errorMessage);
                    } else {
                        if (isPdf) {
                            return res.blob();
                        } else {
                            return res.json();
                        }
                    }
                }).then(data => {
                    if (isPdf) {
                        let filename = 'Deposits_Summery.pdf';
                        showFile(data, filename);
                        this.setState({ loading: false });
                    } else {
                        let respData = [];
                        if (Object.keys(data).length > 0) {
                            Object.keys(data).map(item => {
                                respData.push({
                                    transType: item,
                                    noOfTrans: data[item].totalTransactions,
                                    amount: data[item].totalAmount
                                });
                            })
                        }
                        this.setState({
                            depositSummery: respData, loading: false
                        })
                    }
                }).catch(
                    (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self)
                        this.setState({ loading: false })
                    }
                );

        } else if (reportName == "EventPayments") {
            this.setState({ loading: true });
            let url = `/reports/eventsReport?mealSchoolId=${userInfo.schoolId}`;
            url = url + `${isPdf ? '&isExport=true' : ''}`;
            url = url + `&schoolYear=${sessionStorage.getItem('schoolYearValue')}&startDate=${moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss")}&access_token=`;
            get(url).then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    if (isPdf) {
                        return res.blob();
                    } else {
                        return res.json();
                    }
                }
            }).then(data => {
                if (isPdf) {
                    let filename = 'purchase_events.pdf';
                    showFile(data, filename);
                    this.setState({ loading: false });
                } else {
                    let eventList = [];
                    (data.response || []).forEach(item => {
                        let tot = 0.00;
                        (item.students || []).forEach(stud => {
                            stud['fullName'] = stud.lastName + ', ' + stud.firstName;
                            tot = tot + parseFloat(convertTwoDecimalPoint(stud.transactionAmount))
                        })
                        item['totalAmt'] = tot;
                        eventList.push(item)
                    })
                    this.setState({
                        eventsPayments: eventList, loading: false
                    })
                }
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    this.setState({ loading: false })
                }
            );

        } else if (reportName == "Donations") {
            this.setState({ loading: true });
            get(`/reports/donations/${userInfo.schoolId}?&startDate=${moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss")}&schoolYear=${sessionStorage.getItem('schoolYearValue')}&isExport=${isPdf}&access_token=`).then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    if (isPdf) {
                        return res.blob();
                    } else {
                        return res.json();
                    }
                }
            }).then(data => {
                if (isPdf) {
                    let filename = 'Donations_Report.pdf';
                    showFile(data, filename);
                    this.setState({ loading: false });
                } else {
                    console.log(JSON.stringify(data.resp));
                    this.setState({
                        donationsReport: data.resp, loading: false
                    })
                }
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    this.setState({ loading: false })
                }
            );

        }
    }

    getSelectDate = (dateV, isPdf, gradeName, searchVal) => {
        console.log("Calling getSelectDate");
        const { reportName } = this.props.match.params
        console.log("Get Data of", reportName)
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let _self = this;
        if (reportName === "AccountBalance") {
            this.setState({ loading: true })
            get('/reports/accBalanceOnDate/' + userInfo.schoolId + '?schoolYear=' + sessionStorage.getItem("schoolYearValue") + '&isExport=' + isPdf + '&dateV=' + dateV + '&access_token=').then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    if (isPdf) {
                        return res.blob();
                    } else {
                        return res.json();
                    }
                }
            }).then(data => {
                console.log("data:::::::::::::", data);
                let resultData = (data.response || [])
                if (isPdf) {
                    this.setState({ loading: false });
                } else {
                    resultData.map(item => { //pushes all students for grade selected into an array
                        item.accBalance = item.bal;
                    });
                    let columns = this.getColumns(resultData);
                    const gradeFilterData = resultData.filter(rec => {
                        if ((gradeName || '0') == '0') {
                            return true;
                        } else {
                            return rec.grade == gradeName;
                        }
                    });
                    let searchFilterData = [...gradeFilterData];
                    if ((searchVal || '').length > 0) {
                        let searchData = []
                        searchFilterData.forEach(obj => {
                            if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(searchVal.toLowerCase())) {
                                searchData.push(obj);
                            } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(searchVal.toLowerCase())) {
                                searchData.push(obj);
                            } else if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(searchVal.toLowerCase())) {
                                searchData.push(obj);
                            }
                            else if (obj.parent != null && (obj.parent.toLowerCase()).startsWith(searchVal.toLowerCase())) {
                                searchData.push(obj);
                            } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(searchVal.toLowerCase())) {
                                searchData.push(obj);
                            }
                        });
                        searchFilterData = [...searchData];
                    }

                    this.setState({
                        students: resultData,
                        data: searchFilterData,
                        columns: columns,
                        loading: false,
                        studentCount: resultData.length
                    });
                }
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    this.setState({ loading: false })
                }
            );
        }

    }

    componentWillMount = () => {

        const { reportName } = this.props.match.params
        let reportCall = '';
        switch (reportName) {
            case 'Lowbalance':
                reportCall = this.getLowBalData(false);
                break;
            case 'Purchase':
                reportCall = this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
                break;
            case 'Deposit':
                reportCall = this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
                break;
            case 'DepositSummary':
                reportCall = this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
                break;
            case 'EventPayments':
                reportCall = this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
                break;
            case 'Donations':
                reportCall = this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
                break;
            case 'AccountBalance':
                reportCall = this.getSelectDate(moment(this.state.data).startOf('D').format('YYYY-MM-DD'), false, this.state.accountBalTabIndex);
                break;
            case "Consumption_paymentsReport":
                return [];
                break;
            default:
                reportCall = this.getDataByGrade(0);
        }


        this.setState({}, reportCall)

    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        if (this.state.tabSelect != '') {
            if (document.getElementById('#' + this.state.tabSelect)) {
                document.getElementById('#' + this.state.tabSelect).click();
            }
        }
    }

    accountBalPdf = () => {
        let dateV = moment(this.state.date).format("YYYY-MM-DD");
        let url = '/reports/accBalanceOnDate/' + JSON.parse(sessionStorage.getItem('loggedInUserInfo')).schoolId + '?schoolYear=' + sessionStorage.getItem("schoolYearValue") + '&isExport=true&dateV=' + dateV + '&access_token=';
        /*  if (moment(this.state.date).format('YYYY-MM-DD') == moment().startOf('day').format('YYYY-MM-DD')) {
             url = `/reports/accBalanceSummary/${sessionStorage.getItem('SchoolId')}?isDistrict=false&schoolYear=${sessionStorage.getItem('schoolYearValue')}&isExport=true&access_token=`;
         } */
        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = "Account Balance Report";
            showFile(blob, filename);
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this)
                this.setState({ loading: false })
            }
        )
    }
    buildAccountBalFormatForExport = () => {
        let fData = [];
        this.state.data.map(item => {
            if ((item.accBalance || 0.00) !== 0) {
                fData.push([{ value: item.studentId || '' }, { value: item.grade || '' }, { value: item.firstName || '' }, { value: item.lastName || '' }
                    , { value: item.parent || '' }, { value: item.pin || '' }, { value: item.accBalance || 0.00 }]);
            }
        })
        return (
            [{
                columns: [{ title: 'Student ID' }, { title: 'Grade' }, { title: 'First Name' }, { title: 'Last Name' },
                { title: 'Parent' }, { title: 'PIN' }, { title: `Balance (${currency_symbol()})` }],
                data: fData
            }]
        )
    }
    buildLowBalFormatForExport = () => {
        let fData = [];
        let result = [];
        this.state.lowBalReport.map(item => {
            fData.push([item.firstName || '', item.lastName || '', item.studentId || '', item.gradeName || '', item.userName || '', item.teacherName || '', item.accBalance || 0.00]);
        });

        const _title = `${this.state.lowBalFilter.filter === 'DEFAULT' ? 'LOW BALANCE CRITERIA RANGE (' + currency_symbol() + '):' + (this.state.mapKeyVal.minLowBalance || 0) + ' to ' + (this.state.mapKeyVal.maxLowBalance || 0)
            : 'LOW BALANCE CRITERIA RANGE (' + currency_symbol() + '):' + this.state.lowBalFilter.opr === 'E' ? 'Equals to ' + this.state.lowBalFilter.amount :
                this.state.lowBalFilter.opr === 'L' ? 'Less than ' + this.state.lowBalFilter.amount :
                    this.state.lowBalFilter.opr === 'LE' ? 'Less than equals ' + this.state.lowBalFilter.amount :
                        this.state.lowBalFilter.opr === 'G' ? 'Greater than ' + this.state.lowBalFilter.amount :
                            this.state.lowBalFilter.opr === 'GE' ? 'Greater than equals ' + this.state.lowBalFilter.amount : ''
            }`;
        result.push(
            {
                columns: ['', ''],
                data: [['Title:', _title || ''], ['', '']]
            }
        )
        result.push(
            {
                columns: ['First Name', 'Last Name', 'Student Id', 'Grade', 'Parent',
                    'Teacher', `Balance (${currency_symbol()})`],
                data: fData
            }
        );
        return result;
    }
    buildDepositReportFormatForExport = () => {
        let fData = [];
        let result = [];
        this.state.transactionData.map(row => {
            fData.push([
                row.studentId,
                row.studentLName,
                row.studentFName,
                row.transactionDate,
                row.transactionTime,
                row.type,
                `${currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}`,
                `${row.paymentType === "Online" ? row.transferId :
                    (row.paymentType === "CreditCard" ? row.checkNum :
                        (row.paymentType === 'Check' ? row.checkNum : ''))}`,
                row.user
            ]);
        });
        result.push(
            {
                columns: ['', ''],
                data: [['Title:', 'Deposit Report'], ['', '']]
            }
        )
        result.push(
            {
                columns: [
                    "Student Id",
                    "Student First Name",
                    "Student Last Name",
                    "Transaction Date",
                    "Transaction Time",
                    "Type",
                    `Amount (${currency_symbol()})`,
                    'Check/CC TX. No./TX. ID',
                    "User"
                ],
                data: fData
            }
        );
        return result;
    }
    buildDepSummeryFormatForExport = () => {
        let fData = [];
        let result = [];
        this.state.depositSummery.map(row => {
            fData.push([
                row.transType,
                row.noOfTrans,
                `${currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}`]);

        });
        result.push(
            {
                columns: ['', ''],
                data: [['Title:', 'Deposit Summery Report'], ['', '']]
            }
        )
        result.push(
            {
                columns: [
                    "Transaction Type",
                    "Total Transactions",
                    "Transaction Amount"
                ],
                data: fData
            }
        );
        return result;
    }
    buildPurchaseReportFormatForExport = () => {
        let fData = [];
        let result = [];
        this.state.purchaseData.map(row => {
            fData.push([
                row.studentId,
                row.studentFName,
                row.studentLName,
                row.transactionDate,
                row.transactionTime,
                `${row.itemPurchased === "TransferDR" ? 'Transfer Withdrawal' : row.itemPurchased}`,
                row.category,
                `${currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}`,
                row.transactionDesc
            ]);
        });
        result.push(
            {
                columns: ['', ''],
                data: [['Title:', 'Purchase Report'], ['', '']]
            }
        )
        result.push(
            {
                columns: ["Student Id", "Student First Name", "Student Last Name", "Transaction Date", "Transaction Time", "Type", "Category", `Amount (${currency_symbol()})`, "Description"],
                data: fData
            }
        );
        return result;
    }
    deleteDepositRecord = (recId) => {
        this.setState({ loading: true });
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        _delete('/transactions/removePurchaseTrx?trxId=' + recId + '&mealSchoolId=' + userInfo.schoolId + '&access_token=')
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data) => {
                _addNotification('Successfully deleted deposit record.', this);
                this.setState({ loading: false, showDelDepModal: false, deleteDepRecId: 0 });
                this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
            }).catch(error => {
                this.setState({ loading: false, showDelDepModal: false, deleteDepRecId: 0 });
                _addNotificationError('Could not delete deposit record.', this);
            });
    }
    previousPage = () => {
        if (this.state.currentPage !== 0)
            this.setState({ currentPage: this.state.currentPage - 1 })
    }
    nextPage = () => {
        if ((this.state.currentPage + 1) * 20 < this.state.students.length)
            this.setState({ currentPage: this.state.currentPage + 1 })
    }
    downloadReport = (selectedReportType) => {
        let isSchoolrequired = false;
        let _refNotify = this.props.refNotify;
        let _self = this;
        let schoolID = parseInt(sessionStorage.getItem('SchoolId'))

        let schoolYear = parseInt(sessionStorage.getItem('schoolYearValue'))
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));

        //this.setState({loading: true})
        let start = moment(this.state.startDate).format('YYYY-MM-DD') + "T00:00:00";
        let end = moment(this.state.endDate).format('YYYY-MM-DD') + "T23:59:59";
        let districtID = userInfo.districtId
        /*  if(selectedReportType == 4 || selectedReportType == 5) {
             var date = new Date(this.state.date);
             var firstDay = formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
             var lastDay = formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
             var yearMonth = date.getFullYear()+""+(date.getMonth()+1)
         } */
        if (selectedReportType !== 0) {
            let _url = ""
            let reportType = parseInt(selectedReportType)
            switch (reportType) {
                case 1:
                    if (!schoolID)
                        isSchoolrequired = true;
                    end = moment(this.state.startDate).format('YYYY-MM-DD') + "T23:59:59"
                    _url = '/reports/revenueReport/' + schoolID + '?startDate=' + moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                        '&schoolYear=' + schoolYear + '&access_token='
                    break
                case 2:
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear
                    _url = '/reports/basicClaimReport?districtId=' + districtID
                        + '&startDate=' + moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                        '&schoolYear=' + schoolYear + '&access_token='
                    break
                case 3:
                    _url = '/reports/generateAuditReport?mealSchoolId=' + schoolID
                        + '&startDate=' + moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
                        '&schoolYear=' + schoolYear + '&access_token='
                    break
                case 4:
                    if (!schoolID)
                        isSchoolrequired = true;
                    const _firstDay = moment(moment(this.state.date.startOf('month')).format('YYYY-MM-DDT00:00:00'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
                    const _lastDay = moment(moment(this.state.date.endOf("month")).format('YYYY-MM-DDT23:59:59'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
                    const _yearMonth = this.state.date.format('YYYYMM');
                    _url = '/reports/incomeReport/' + schoolID + '?&startDate=' + _firstDay + '&endDate=' + _lastDay + '&itemType=' + (this.state.mealType) +
                        '&yearMonth=' + _yearMonth + '&access_token='
                    break
                case 5:
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear;
                    const _fDay = moment(moment(this.state.date.startOf('month')).format('YYYY-MM-DDT00:00:00'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
                    const _lDay = moment(moment(this.state.date.endOf("month")).format('YYYY-MM-DDT23:59:59'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
                    const _yMonth = this.state.date.format('YYYYMM');
                    _url = '/reports/auditDailyEditCheck?districtId=' + districtID + '&mealSchoolId=' + schoolID
                        + '&startDate=' + _fDay + '&endDate=' + _lDay + '&itemType=' + (this.state.mealType) +
                        '&schoolYear=' + schoolYear + '&yearMonth=' + _yMonth + '&access_token='
                    break
                case 6:
                    schoolYear = this.state.userInfo.schools[0].activeSchoolYear
                    _url = '/reports/onlinePaymetReport?districtId=' + districtID
                        + '&startDate=' + moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
                        '&schoolYear=' + schoolYear + '&access_token='
                    break
                case 7:
                    if (!schoolID)
                        isSchoolrequired = true;
                    const _startDay = moment(moment(this.state.date.startOf('month')).format('YYYY-MM-DDT00:00:00'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
                    const _endDay = moment(moment(this.state.date.endOf("month")).format('YYYY-MM-DDT23:59:59'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
                    _url = '/reports/revenueReport/' + schoolID + '?&startDate=' + _startDay + '&endDate=' + _endDay + '&itemType=' + (this.state.mealType) +
                        '&schoolYear=' + schoolYear + '&access_token='
                    break
            }
            if (isSchoolrequired) {

                _addNotificationError("Please select school", _self)
                return
            }
            console.log("jjjjjj")

            this.setState({ loading: true })

            get(_url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 417 || response.status === 422) {
                            return response.json();
                        }
                        //throw Error(response.errorMessage);
                    }
                    console.log('response', response);
                    return response;
                }).then(res => {
                    if (res.statusCode === 417) {
                        //_addNotificationError(res.errorMessage,this)
                        throw Error(res.errorMessage);
                    } else if (res.statusCode === 422) {
                        throw Error(res.statusMessage);
                    } else {
                        return res.blob();
                    }
                }).then(blob => {
                    let filename = "DailyEditCheckReport";
                    showFile(blob, filename);
                    this.setState({ loading: false })
                }).catch(
                    (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self)
                        //console.log('Get Excel File response', error)
                        this.setState({ loading: false })
                    }
                )
            return
        }

    }
    getDataByGrade = (gradeName) => {
        let teachers = [];
        let studentsByGrade = [];
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        (get('/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=true&schoolId=' + schoolId + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='))
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                console.log("allStudentData", this.state.allStudentData);
                console.log('data', data);
                const stData = data['_embedded']['studentUsers'];
                let activeStData = stData; //_.filter(stData, function(o) { return o.register; });
                this.setState({ studentsCount: activeStData.length, });
                if ((gradeName || '0') == '0') {
                    return activeStData.map(item => {
                        let _id = item.studentId;
                        return {
                            _id,
                            ...item
                        };
                    });
                } else {
                    activeStData.map(item => { //pushes all students for grade selected into an array
                        let _gradeName = item.gradeName;
                        if (_gradeName === gradeName) {
                            studentsByGrade.push(item);
                        }
                    });
                    return studentsByGrade.map(item => {
                        let _id = item.studentId;
                        return {
                            _id,
                            ...item
                        };
                    });
                }
            }).then(data => {
                /* You can do all the function calls from in here in the same .then(data => {}) call aboves */
                // console.log("Students by grade " + JSON.stringify(studentsByGrade));
                this.setState({ studentsCount: studentsByGrade.length });
                let columns = this.getColumns(data);

                this.setState({
                    students: data,
                    data: data,
                    columns: columns,
                    loading: false,
                    studentCount: data.length
                })
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
    }
    getColumns = (data) => {
        let columns = [];
        let header = ['NAME', 'MOBILE NO', 'PARENT EMAILID', 'A/C BALANCE', 'ACTIONS'];
        if (data.length === 0) {
            header.map(key =>
                columns.push({ Header: key }));
        }
        else {
            columns.push({
                accessor: 'firstName',
                Header: 'Student',
                Cell: props => <span>{props.original.lastName + ', ' + props.original.firstName} { }</span>,
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'studentId',
                Header: 'Student Id',
                Cell: props => <span>{props.original.studentId}</span>,
                style: { textAlign: 'center' }
            })
            columns.push({
                accessor: 'pin', // formatted mobile num for display
                Header: 'Pin',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'parent',
                Header: 'Parent',
                style: { textAlign: 'center' }
            });
            /* columns.push({
                accessor: 'mobileNo', // formatted mobile num for display
                Header: 'Mobile No',
                style: { textAlign: 'center' }
            }); */
            columns.push({
                accessor: 'accBalance', // formatted mobile num for display
                Header: `Balance (${currency_symbol()})`,
                style: { textAlign: 'center' },
                Cell: ({ row }) => (
                    <span style={{ textAlign: 'center' }}>
                        {currency_symbol() + ' ' + convertTwoDecimalPoint(row._original.accBalance)} </span>)
            });
            if (moment(this.state.date).format('YYYY-MM-DD') == moment().startOf('day').format('YYYY-MM-DD')) {
                columns.push({
                    Header: "Action",
                    width: 100,
                    style: { textAlign: 'center' },
                    Cell: props => {
                        return (
                            <div>
                                <Link to={{
                                    pathname: '/schoolAdmin/accountHistory/' + props.original.displayRecId,
                                    state: {
                                        schoolId: 0
                                    }
                                }}><i className="fa fa-list-alt"></i></Link>
                                {/* <a title="Click"
                        onClick={(event) =>{ 
                            this.context.router.history.push('/schoolAdmin/accountHistory/' + props.original.displayRecId)                           
                            //this.setState({accountHistStudentData:row.original,modalIsOpen:true})
                    }}><i className="fa fa-list-alt"/></a>  */}
                            </div>
                        )
                    }
                })
            }
        }
        return columns;
    }
    filterSchool = () => {
        let s = document.getElementById('search').value;
        //alert(s)
        let filteredData = this.state.students;
        let searchedSchool = [];
        if (s.length > 0) {

            filteredData.forEach(obj => {
                if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.mobileNum != null && (obj.mobileNum.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.parentuser.userName != null && (obj.parentuser.userName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            //.replace(/[()\-" ]+/g, '')
            this.setState({ data: searchedSchool })
        }
        else {
            this.setState({ data: searchedSchool.length == 0 ? filteredData : searchedSchool })
        }
        this.forceUpdate();
    };
    getLowBalData = (isPdf = false) => {
        let _self = this;
        let _lowBalFilter = this.state.lowBalFilter
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolYearValue = sessionStorage.getItem('schoolYearValue');
        let url = '';
        if (_lowBalFilter.filter == 'DEFAULT') {
            url = '/reports/lowBalanceReport?mealSchoolId=' + userInfo.schoolId + '&fileExport=' + isPdf + '&schoolYear=' + schoolYearValue + '&access_token='
        } else {
            url = '/reports/lowBalanceReport?mealSchoolId=' + userInfo.schoolId +
                '&fileExport=' + isPdf + '&schoolYear=' + schoolYearValue + '&amount=' + ((_lowBalFilter.amount === '' ? undefined : _lowBalFilter.amount) || 0.00) + '&operator=' + _lowBalFilter.opr + '&access_token='
        }
        this.setState({ loading: true });
        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = 'Low_balReport.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                console.log(JSON.stringify(data.lowBalanceStudentsList));
                this.setState({
                    lowBalReport: data.lowBalanceStudentsList, mapKeyVal: data.mapKeyVal, loading: false
                })

            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );
    }
    deletePurchaseRec = () => {
        this.setState({ loading: true, deletePurchaseModel: false })
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        _delete("/transactions/removePurchaseTrx?trxId=" + this.state.deletePurchaseId + "&mealSchoolId=" + userInfo.schoolId + "&access_token=")
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                } else {
                    return response.json();
                }
            }).then((response) => {
                if (response.statusCode === 200) {
                    this.setState({ loading: false })
                    _addNotification(response.statusMessage, this);
                    this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
                } else {
                    throw Error(response.errorMessage);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError(error.message, this);
                }
            );
    }
    buildEventPaymentReportFormatForExport = () => {
        let fData = [];
        this.state.eventsPayments.map(item => {
            fData.push([{ value: item.eventName || '' }, { value: item.totalAmt }]);
        })
        return (
            [{
                columns: [{ title: 'Event Name' },
                { title: `Total Amount (${currency_symbol()})` }],
                data: fData
            }]
        );
    }

    buildDonationsReportFormatForExport = () => {
        let fData = [];
        let result = [];
        this.state.donationsReport.map(row => {
            fData.push([
                row.studentId,
                row.studentLName,
                row.studentFName,
                row.user,
                row.transactionDate,
                row.transactionTime,
                row.paymentType,
                `${currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}`,
                row.donationMealCount

            ]);
        });
        result.push(
            {
                columns: ['', ''],
                data: [['Title:', 'Donations Report'], ['', '']]
            }
        )
        result.push(
            {
                columns: [
                    "Student Id",
                    "Student First Name",
                    "Student Last Name",
                    "Parent Email ID",
                    "Date",
                    "Time",
                    "Type",
                    `Amount Donated (${currency_symbol()})`,
                    "Meals Donated",
                ],
                data: fData
            }
        );
        return result;
    }
    render() {
        const { location } = this.props;
        const stripeReport = location.state ? location.state.stripeReport : null;
        gradeList = getSchoolGrades();
        const { reportName } = this.props.match.params
        let donationStatus = sessionStorage.getItem('donationStatus')
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };

        return (<div>
            <NotificationSystem ref="notificationSystem" />
            <section className=" full-width clearfix">
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle text-right">
                        <Link to={{
                            pathname: '/schoolAdmin/financialReport',
                            state: { stripeReport: stripeReport }
                        }} className="btn btn-sm btn-primary" style={{ marginBottom: '0px' }}><span >Back</span></Link>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="tabCommon custom-tabCommon">
                                <div className="tab-content">
                                    {reportName === 'AccountBalance' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section1">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Account Balances</h3>
                                                    <div style={{
                                                        display: 'inline-block',
                                                        backgroundColor: 'transparent',
                                                        marginTop: '-7px',
                                                        float: 'right',
                                                        borderRadius: '3px'
                                                    }}>
                                                        <div className="btn-group">
                                                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                        onClick={() => { this.accountBalPdf(); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                </li>
                                                                <li>
                                                                    <TmExportExcel id="AccountBalance"
                                                                        name={"Account balance"}
                                                                        filename={"Account balance"}
                                                                        element={<a id="AccountBalance" title="Click to Download Excel"
                                                                            style={{
                                                                                display: 'block',
                                                                                padding: '3px 20px',
                                                                                clear: 'both',
                                                                                fontWeight: '400',
                                                                                lineHeight: 1.42857143,
                                                                                color: '#333',
                                                                                whiteSpace: 'nowrap',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                                        dataSet={this.buildAccountBalFormatForExport()}
                                                                    />
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="panel-body">
                                                    <div>
                                                        <Tabs>
                                                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                                <label className="custom-label col-md-3 text-right" style={{ margin: '10px 0px 0px 0px', fontSize: '16px' }}> Select Date :</label>
                                                                <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                                                    <Datetime ref='startCalendar' dateFormat={'YYYY/MM/DD'} timeFormat={false}
                                                                        closeOnSelect={true} value={this.state.date}
                                                                        onChange={(e) => {
                                                                            this.setState({ date: moment(e), accBalSearch: '' })
                                                                            this.refs.startCalendar.closeCalendar()
                                                                            this.getSelectDate(moment(e).format('YYYY-MM-DD'), false, this.state.accountBalTabIndex);
                                                                        }} renderInput={this.renderInput} />
                                                                </div>
                                                            </div>
                                                            <TabList>
                                                                {/* <Tab onClick={() => {
                                                                this.setState({ selectAll: false })
                                                                this.state.tabIndex = 0;
                                                            this.getDataByGrade(0) 
                                                        }}>All Grades</Tab> */}
                                                                {gradeList.map((item) => {
                                                                    return <Tab onClick={() => {
                                                                        this.state.tabIndex = item.value;
                                                                        this.setState({ selectAll: false, accountBalTabIndex: item.value, accBalSearch: '' })
                                                                        this.getSelectDate(moment(this.state.date).startOf('D').format('YYYY-MM-DD'), false, item.value);
                                                                    }}> {item.label}</Tab>
                                                                }, this)}
                                                            </TabList>
                                                            <TabPanel>
                                                                <div className="row">
                                                                    <div className="col-xs-12 pull-left">
                                                                        <input type="text" id="search" autoComplete='off' value={this.state.accBalSearch || ''} onChange={(e) => {
                                                                            let searchText = e.target.value;
                                                                            this.setState({ accBalSearch: e.target.value }, () => {
                                                                                const _searchText = this.state.accBalSearch.replace(/[^\w\s]/gi, '');
                                                                                this.getSelectDate(moment(this.state.date).startOf('D').format('YYYY-MM-DD'), false, this.state.accountBalTabIndex, _searchText);

                                                                            });

                                                                        }}
                                                                            className="search form-control"
                                                                            style={{
                                                                                float: 'left',
                                                                                margin: '5px 0'
                                                                            }}
                                                                            name="search"
                                                                            placeholder="Search.."

                                                                        />
                                                                    </div>
                                                                </div>
                                                                <ReactTable className="-striped -highlight"
                                                                    ref={r => (this.checkboxTable = r)}
                                                                    data={_.orderBy(this.state.data, ['lastName', 'firstName'], ['asc'])}
                                                                    columns={this.state.columns}
                                                                    defaultPageSize={10}
                                                                    {...checkboxProps}
                                                                />
                                                            </TabPanel>
                                                            {gradeList.map(function (key) {
                                                                return (
                                                                    <TabPanel>
                                                                        <div className="row">
                                                                            <div className="col-xs-12 pull-left">
                                                                                <input type="text" id="search" autoComplete='off' value={this.state.accBalSearch || ''} onChange={(e) => {
                                                                                    let searchText = e.target.value;
                                                                                    this.setState({ accBalSearch: e.target.value }, () => {
                                                                                        const _searchText = this.state.accBalSearch.replace(/[^\w\s]/gi, '');
                                                                                        this.getSelectDate(moment(this.state.date).startOf('D').format('YYYY-MM-DD'), false, this.state.accountBalTabIndex, _searchText);

                                                                                    });

                                                                                }}
                                                                                    className="search form-control"
                                                                                    style={{
                                                                                        float: 'left',
                                                                                        margin: '5px 0'
                                                                                    }}
                                                                                    name="search"
                                                                                    placeholder="Search.."

                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <ReactTable className="-striped -highlight"
                                                                            ref={r => (this.checkboxTable = r)}
                                                                            data={_.orderBy(this.state.data, ['lastName', 'firstName'], ['asc'])}
                                                                            columns={this.state.columns}
                                                                            defaultPageSize={10}
                                                                            {...checkboxProps}

                                                                        />
                                                                    </TabPanel>)
                                                            }, this)}
                                                        </Tabs>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'Lowbalance' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section2">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Low Balances Report</h3>
                                                    <div style={{
                                                        display: 'inline-block',
                                                        backgroundColor: 'transparent',
                                                        marginTop: '-7px',
                                                        float: 'right',
                                                        borderRadius: '3px'
                                                    }}>
                                                        <div className="btn-group">
                                                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                        onClick={() => { this.getLowBalData(true); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                </li>
                                                                <li>
                                                                    <TmExportExcel id="LowBalance"
                                                                        name={"Low balance report"}
                                                                        filename={"Low balance report"}
                                                                        element={<a title="Click to Download Excel" id="lowBalance"
                                                                            style={{
                                                                                display: 'block',
                                                                                padding: '3px 20px',
                                                                                clear: 'both',
                                                                                fontWeight: '400',
                                                                                lineHeight: 1.42857143,
                                                                                color: '#333',
                                                                                whiteSpace: 'nowrap',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                                        dataSet={this.buildLowBalFormatForExport()}
                                                                    />
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="panel-body">
                                                    <div className="col-md-12">
                                                        <div className="alert alert-info " style={{ textAlign: "left", padding: "10px" }}>
                                                            <div className="row">
                                                                <div className="col-md-11">
                                                                    <ul>
                                                                        <li><input type="radio" name="lowBalFilter" checked={this.state.lowBalFilter.filter == 'DEFAULT'} defaultChecked={true}
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    let _lowBalFilter = this.state.lowBalFilter;
                                                                                    _lowBalFilter.filter = 'DEFAULT';
                                                                                    this.setState({ lowBalFilter: _lowBalFilter },
                                                                                        this.getLowBalData(false))
                                                                                }
                                                                            }} /><span style={{ marginLeft: '10px' }}>LOW BALANCE CRITERIA RANGE ({currency_symbol()}): {this.state.mapKeyVal.minLowBalance + ' to ' + this.state.mapKeyVal.maxLowBalance}</span></li>
                                                                        <li><input type="radio" style={{ position: 'absolute', marginTop: '10px' }} checked={this.state.lowBalFilter.filter == 'CUSTOM'} name="lowBalFilter"
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    let _lowBalFilter = this.state.lowBalFilter;
                                                                                    _lowBalFilter.filter = 'CUSTOM';
                                                                                    this.setState({ lowBalFilter: _lowBalFilter },
                                                                                        this.getLowBalData(false))
                                                                                }
                                                                            }} />
                                                                            <div style={{ marginLeft: '23px', display: 'inline-table' }}>
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <select className="form-control" value={this.state.lowBalFilter.opr} onChange={(e) => {
                                                                                            let _lowBalFilter = this.state.lowBalFilter;
                                                                                            _lowBalFilter.opr = e.target.value;
                                                                                            this.setState({ lowBalFilter: _lowBalFilter })
                                                                                        }}>
                                                                                            <option value="E">Equals</option>
                                                                                            <option value="L">Less than</option>
                                                                                            <option value="LE">Less than equals</option>
                                                                                            <option value="G">Greater than</option>
                                                                                            <option value="GE">Greater than equals</option>
                                                                                        </select>
                                                                                    </div>
                                                                                    <div className="col-md-4">
                                                                                        <input type="number" className="form-control" value={this.state.lowBalFilter.amount} placeholder="0.00" onChange={(e) => {
                                                                                            let _lowBalFilter = this.state.lowBalFilter;
                                                                                            _lowBalFilter.amount = e.target.value;
                                                                                            this.setState({ lowBalFilter: _lowBalFilter })
                                                                                        }} />
                                                                                    </div>
                                                                                    <div className="col-md-1">
                                                                                        <button type='button' className="btn btn-xs btn-success" style={{ margin: '0px' }} onClick={() => {
                                                                                            this.getLowBalData(false);
                                                                                        }}>Go</button>
                                                                                    </div>

                                                                                </div>
                                                                            </div></li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-1">
                                                                    {/*  <a title="Click to Download PDF"
                                                                        onClick={() => { this.getLowBalData(true) }//this.quickReports('Pdf','currentDay')
                                                                        } target='_blank'
                                                                        className="fa fa-file-pdf-o fa-2x pull-right"><i /></a> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <LowBalReport lowBalData={this.state.lowBalReport} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'Deposit' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section3">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Deposits Report</h3>
                                                    <div style={{
                                                        display: 'inline-block',
                                                        backgroundColor: 'transparent',
                                                        marginTop: '-7px',
                                                        float: 'right',
                                                        borderRadius: '3px'
                                                    }}>
                                                        <div className="btn-group">
                                                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                        onClick={() => { this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, true); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                </li>
                                                                <li>
                                                                    <TmExportExcel id="depReport"
                                                                        name={"Deposits Report"}
                                                                        filename={"Deposits Report"}
                                                                        element={<a title="Click to Download Excel" id="depReport"
                                                                            style={{
                                                                                display: 'block',
                                                                                padding: '3px 20px',
                                                                                clear: 'both',
                                                                                fontWeight: '400',
                                                                                lineHeight: 1.42857143,
                                                                                color: '#333',
                                                                                whiteSpace: 'nowrap',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                                        dataSet={this.buildDepositReportFormatForExport()}
                                                                    />
                                                                </li>

                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="panel-body">
                                                    <div className='row' style={{ marginTop: '5px', marginBottom: '5px', fontSize: '16px' }}>
                                                        <div className='col-md-2'>
                                                            <label>Select date range:</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <DateTimeRangePicker
                                                                startDate={this.state.selectedDates.startDate}
                                                                endDate={this.state.selectedDates.endDate}
                                                                isReport={false}
                                                                applyCallback={(event, picker) => {
                                                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                                                }}
                                                                isDateShow={true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-12">
                                                            {/* {this.deposistsSummery(this.state.transactionData)} */}
                                                            <ul id={'deptReport'} className='pull-right' style={{ WebkitColumnCount: 4, MozColumnCount: 4, columnCount: 4, textAlign: 'center' }}>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-12">
                                                            <ReactTable ref={(r) => this.deptTable = r} id={'deptTbl'}
                                                                filterable
                                                                columns={[
                                                                    {
                                                                        Header: "Student First Name",
                                                                        id: "StudentFName",
                                                                        style: { textAlign: 'center' },
                                                                        accessor: 'studentFName',
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row.studentFName || '').toLowerCase().includes(filter.value.toLowerCase())
                                                                        },
                                                                        Footer: (props) => {
                                                                            const { data } = props;
                                                                            const tempList = (data).map(d => d._original);
                                                                            return <div style={{ textAlign: "center" }}>Total:  {tempList.length}</div>
                                                                        }
                                                                    },
                                                                    {
                                                                        Header: "Student Last Name",
                                                                        id: "studentLName",
                                                                        style: { textAlign: 'center' },
                                                                        accessor: 'studentLName',
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row.studentLName || '').toLowerCase().includes(filter.value.toLowerCase())
                                                                        }
                                                                    },
                                                                    {
                                                                        Header: "Pin",
                                                                        accessor: "pin",
                                                                        width: 100,
                                                                        style: { textAlign: 'center' },
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row['pin']).startsWith(filter.value.toLowerCase())
                                                                        },
                                                                    },
                                                                    {
                                                                        Header: "Date",
                                                                        accessor: "transactionDate",
                                                                        width: 100,
                                                                        style: { textAlign: 'center' },
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row['transactionDate']).startsWith(filter.value.toLowerCase())
                                                                        },
                                                                    },
                                                                    {
                                                                        Header: "Time",
                                                                        accessor: "transactionTime",
                                                                        width: 100,
                                                                        style: { textAlign: 'center' },
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row['transactionTime']).startsWith(filter.value.toLowerCase())
                                                                        },
                                                                    },
                                                                    {
                                                                        Header: "Type",
                                                                        id: 'type',
                                                                        accessor: 'type',
                                                                        style: { textAlign: 'center' },
                                                                        accessor: row => {
                                                                            return (
                                                                                <span>
                                                                                    {row.type}
                                                                                    {/* {row.paymentType === "Online" ? row.paymentType :row.note==="Lunch balance added from POS app."?row.paymentType + ' - By POS': row.paymentType + ' - By School'} */}

                                                                                </span>
                                                                            );
                                                                        }, width: 150,
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            /* return (_row['paymentType']).toLowerCase().startsWith(filter.value.toLowerCase()) */
                                                                            return (_row['type']).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                        },
                                                                        Filter: ({ filter, onChange }) => {
                                                                            return (
                                                                                <select className="form-control"
                                                                                    onChange={event => onChange(event.target.value)}
                                                                                    value={filter ? filter.value : 'all'}
                                                                                >
                                                                                    <option value={''}>{''}</option>
                                                                                    {_.map(
                                                                                        _.uniq(
                                                                                            _.map(this.state.transactionData, function (obj) {
                                                                                                /*  return obj.paymentType; */
                                                                                                return obj.type;
                                                                                            })
                                                                                        )).map(item =>
                                                                                            <option value={item}>{item}</option>
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                            )
                                                                        },
                                                                        Footer: (props) => {
                                                                            const { data } = props;
                                                                            const tempList = (data).map(d => d._original);
                                                                            const groupData = groupBy(tempList, 'type');
                                                                            const id = document.getElementById('deptReport');
                                                                            const lstString = Object.keys(groupData).map((item) => {
                                                                                return `<li><label class="color-1">Total ${item} Count:</label> <strong class="color-4">${groupData[item].length}</strong></li>`
                                                                            })

                                                                            if (id) {

                                                                                id.innerHTML = lstString.join('');
                                                                            }
                                                                            return <div style={{ textAlign: "center" }}></div>
                                                                        }
                                                                    },
                                                                    {
                                                                        Header: `Amount (${currency_symbol()})`,
                                                                        id: 'amount',
                                                                        width: 100,
                                                                        filterable: false,
                                                                        accessor: row => {
                                                                            return (
                                                                                <div style={{ textAlign: "center" }}>
                                                                                    {currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}
                                                                                </div>
                                                                            );
                                                                        },
                                                                        Footer: (props) => {
                                                                            const { data } = props;
                                                                            const tempList = (data).map(d => d._original);
                                                                            return <div style={{ textAlign: "center" }}> {currency_symbol() + ' ' + (_.sum(_.map(tempList, d => d.amount))).toFixed(2)}</div>
                                                                        }
                                                                    },
                                                                    {
                                                                        Header: "Check/CC TX. No./TX. ID",
                                                                        id: 'transaction',
                                                                        style: { textAlign: 'center' },
                                                                        accessor: row => {
                                                                            return (
                                                                                <span>
                                                                                    {row.paymentType === "Online" ? row.transferId :
                                                                                        (row.paymentType === "CreditCard" ? row.checkNum :
                                                                                            (row.paymentType === 'Check' ? row.checkNum : null))}
                                                                                </span>
                                                                            );
                                                                        },
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            const _fieldName = ['transferId', 'checkNum']
                                                                            return ((_row[_fieldName[0]]).toLowerCase().startsWith(filter.value.toLowerCase()) ||
                                                                                (_row[_fieldName[1]]).toLowerCase().startsWith(filter.value.toLowerCase()))
                                                                        }
                                                                    },
                                                                    {
                                                                        Header: "User",
                                                                        accessor: "user",
                                                                        minWidth: 120,
                                                                        style: { textAlign: 'center' },
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                        }
                                                                    }, {
                                                                        Header: "Action",
                                                                        id: 'action',
                                                                        minWidth: 40,
                                                                        style: { textAlign: 'center' },
                                                                        Cell: ({ row }) => {
                                                                            const recId = row._original.idNumb;
                                                                            return row._original.paymentType === "Online" ? null : <a href="javascript:void(0);" style={{ paddingLeft: '5px' }} onClick={() => {
                                                                                this.setState({ deleteDepRecId: recId, showDelDepModal: true });
                                                                            }}><i className="fa fa-trash-o fa-2x"></i></a>
                                                                        }
                                                                    }

                                                                ]}
                                                                data={_.orderBy(this.state.transactionData, ['studentLName', 'studentFName'], ['asc'])}
                                                                defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'DepositSummary' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section4">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Deposit Summary</h3>
                                                    <div style={{
                                                        display: 'inline-block',
                                                        backgroundColor: 'transparent',
                                                        marginTop: '-7px',
                                                        float: 'right',
                                                        borderRadius: '3px'
                                                    }}>
                                                        <div className="btn-group">
                                                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                        onClick={() => { this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, true); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                </li>
                                                                <li>
                                                                    <TmExportExcel id="depositSummery"
                                                                        name={"Deposit Summery report"}
                                                                        filename={"Deposit Summery report"}
                                                                        element={<a title="Click to Download Excel" id="depositSummery"
                                                                            style={{
                                                                                display: 'block',
                                                                                padding: '3px 20px',
                                                                                clear: 'both',
                                                                                fontWeight: '400',
                                                                                lineHeight: 1.42857143,
                                                                                color: '#333',
                                                                                whiteSpace: 'nowrap',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                                        dataSet={this.buildDepSummeryFormatForExport()}
                                                                    />
                                                                </li>

                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="panel-body">
                                                    <div className='row' style={{ marginTop: '5px', marginBottom: '5px', fontSize: '16px' }}>
                                                        <div className='col-md-2'>
                                                            <label>Select date range:</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <DateTimeRangePicker
                                                                startDate={this.state.selectedDates.startDate}
                                                                endDate={this.state.selectedDates.endDate}
                                                                isReport={false}
                                                                applyCallback={(event, picker) => {
                                                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                                                }}
                                                                isDateShow={true} />
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-12">
                                                            <ReactTable
                                                                filterable
                                                                columns={[
                                                                    {
                                                                        Header: "S.No",
                                                                        filterable: false,
                                                                        width: 100,
                                                                        style: { textAlign: 'center' },
                                                                        Cell: row => {
                                                                            return <span>{row.index + 1}</span>
                                                                        }
                                                                    },
                                                                    {
                                                                        Header: "Transaction Type",
                                                                        accessor: "transType",
                                                                        style: { textAlign: 'center' },
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                        },
                                                                        Filter: ({ filter, onChange }) => {
                                                                            return (
                                                                                <select className="form-control"
                                                                                    onChange={event => onChange(event.target.value)}
                                                                                    value={filter ? filter.value : 'all'}
                                                                                >
                                                                                    <option value={''}>{''}</option>
                                                                                    {_.map(
                                                                                        _.uniq(
                                                                                            _.map(this.state.depositSummery, function (obj) {
                                                                                                return obj.transType;
                                                                                            })
                                                                                        )).map(item =>
                                                                                            <option value={item}>{item}</option>
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                            )
                                                                        }
                                                                    },
                                                                    {
                                                                        Header: "Total Transactions",
                                                                        filterable: false,
                                                                        accessor: "noOfTrans",
                                                                        style: { textAlign: 'center' },
                                                                        Cell: row => (<span style={{ textAlign: 'center' }}>{row.original.noOfTrans}</span>)
                                                                    },
                                                                    {
                                                                        Header: "Transaction Amount",
                                                                        accessor: "amount",
                                                                        style: { textAlign: 'center' },
                                                                        filterable: false,
                                                                        Cell: row => (<span style={{ textAlign: 'center' }}>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.original.amount)}</span>)
                                                                    }
                                                                ]} data={this.state.depositSummery} defaultPageSize={10} className="-striped -highlight" />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'Purchase' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section5">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Purchase Reports</h3>

                                                    <div style={{
                                                        display: 'inline-block',
                                                        backgroundColor: 'transparent',
                                                        marginTop: '-7px',
                                                        float: 'right',
                                                        borderRadius: '3px'
                                                    }}>
                                                        <div className="btn-group">
                                                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                        onClick={() => { this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, true); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                </li>
                                                                <li>
                                                                    <a title="Click to Download Excel" style={{
                                                                        display: 'block',
                                                                        padding: '3px 20px',
                                                                        clear: 'both',
                                                                        fontWeight: '400',
                                                                        lineHeight: 1.42857143,
                                                                        color: '#333',
                                                                        whiteSpace: 'nowrap',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                        onClick={() => { this.downloadPurchaseExcel(this.state.selectedDates.startDate, this.state.selectedDates.endDate); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-excel-o" /> Excel</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="panel-body">
                                                    <div className='row' style={{ marginTop: '5px', marginBottom: '5px', fontSize: '16px' }}>
                                                        <div className='col-md-2'>
                                                            <label>Select date range:</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <DateTimeRangePicker
                                                                startDate={this.state.selectedDates.startDate}
                                                                endDate={this.state.selectedDates.endDate}
                                                                isReport={false}
                                                                applyCallback={(event, picker) => {
                                                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                                                }}
                                                                isDateShow={true} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <ul id={'purchaseSummery'} style={{ WebkitColumnCount: 3, MozColumnCount: 3, columnCount: 3, textAlign: 'center' }}>
                                                        </ul>
                                                        {/* {this.purchaseSummery(this.state.purchaseData)} */}
                                                    </div>
                                                    <div className="col-md-12" style={{ fontSize: '13px' }}>
                                                        <ReactTable
                                                            filterable
                                                            columns={[
                                                                {
                                                                    Header: "Student First Name",
                                                                    id: "studentFName",
                                                                    style: { textAlign: 'center' },
                                                                    accessor: 'studentFName',
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        return (_row.studentFName || '').toLowerCase().includes(filter.value.toLowerCase())
                                                                    },
                                                                    Footer: (props) => {
                                                                        const { data } = props;
                                                                        const tempList = (data).map(d => d._original);
                                                                        return <div style={{ textAlign: "center" }}>Total:  {tempList.length}</div>
                                                                    }
                                                                },
                                                                {
                                                                    Header: "Student Last Name",
                                                                    id: "studentLName",
                                                                    style: { textAlign: 'center' },
                                                                    accessor: 'studentLName',
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        return (_row.studentLName || '').toLowerCase().includes(filter.value.toLowerCase())
                                                                    }
                                                                }
                                                                ,
                                                                {
                                                                    Header: "Pin",
                                                                    id: "pin",
                                                                    width: 70,
                                                                    style: { textAlign: 'center' },
                                                                    accessor: row => {
                                                                        return (
                                                                            <span>
                                                                                {row.pin}
                                                                            </span>
                                                                        );
                                                                    },
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        return (_row.pin).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                    }
                                                                },
                                                                {
                                                                    Header: "Date",
                                                                    accessor: "transactionDate",
                                                                    width: 100,
                                                                    style: { textAlign: 'center' },
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                    },
                                                                    Footer: (props) => {
                                                                        const { data } = props;
                                                                        const tempList = (data).map(d => d._original);
                                                                        const groupData = groupBy(tempList, 'itemPurchased');
                                                                        const id = document.getElementById('purchaseSummery');
                                                                        const lstString = Object.keys(groupData).map((item) => {
                                                                            return `<li><label class="color-1">Total ${item} Count:</label> <strong class="color-4">${groupData[item].length}</strong></li>`
                                                                        })

                                                                        if (id) {

                                                                            id.innerHTML = lstString.join('');
                                                                        }
                                                                        return <div style={{ textAlign: "center" }}></div>
                                                                    }
                                                                },
                                                                {
                                                                    Header: "Time",
                                                                    accessor: "transactionTime",
                                                                    width: 100,
                                                                    style: { textAlign: 'center' },
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                    }
                                                                },
                                                                {
                                                                    Header: "Type",
                                                                    id: 'type',
                                                                    style: { textAlign: 'center' },
                                                                    accessor: row => {
                                                                        return (
                                                                            <span>
                                                                                {row.itemPurchased === "TransferDR" ? 'Transfer Withdrawal' : row.itemPurchased}
                                                                            </span>
                                                                        );
                                                                    },
                                                                    width: 100,
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        return (_row['itemPurchased']).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                    },
                                                                    Filter: ({ filter, onChange }) => {
                                                                        return (
                                                                            <select className="form-control form-control-sm"
                                                                                onChange={event => onChange(event.target.value)}
                                                                                value={filter ? filter.value : 'all'}
                                                                            >
                                                                                <option value={''}>{''}</option>
                                                                                {_.map(
                                                                                    _.uniq(
                                                                                        _.map(this.state.purchaseData, function (obj) {
                                                                                            return obj.itemPurchased;
                                                                                        })
                                                                                    )).map(item =>
                                                                                        <option value={item}>{item}</option>
                                                                                    )
                                                                                }
                                                                            </select>
                                                                        )
                                                                    }
                                                                },
                                                                {
                                                                    Header: "Category",
                                                                    accessor: "category",
                                                                    style: { textAlign: 'center' },
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                    }
                                                                },
                                                                {
                                                                    Header: 'Item Name',
                                                                    id: 'itemName',
                                                                    style: { textAlign: 'left' },
                                                                    width: 250,
                                                                    filterMethod: (filter, row) => {
                                                                        const _row = row._original
                                                                        const search = filter.value.toLowerCase()
                                                                        return (_row.items || []).some(itm => (itm.itemName || '').toLowerCase().includes(search))
                                                                    },
                                                                    Cell: (row) => {
                                                                        const { original } = row;
                                                                        const { items } = original;
                                                                        return <ul>{(items || []).map(itm => {
                                                                            return <li style={{ lineHeight: '17px', borderBottom: 'solid 2px #cac9c97d' }}><span style={{ wordWrap: 'break-word' }}>{itm.itemName}</span></li>
                                                                        })}</ul>

                                                                    }
                                                                },
                                                                {
                                                                    Header: 'Item Qty',
                                                                    id: 'itemQty',
                                                                    style: { textAlign: 'center' },
                                                                    filterable: false,
                                                                    width: 100,
                                                                    Cell: (row) => {
                                                                        const { original } = row;
                                                                        const { items } = original;
                                                                        return <ul>{(items || []).map(itm => {
                                                                            return <li style={{ lineHeight: '17px', borderBottom: 'solid 2px #cac9c97d' }}><span>{itm.qty}</span></li>
                                                                        })}</ul>

                                                                    }
                                                                },
                                                                {
                                                                    Header: `Amount (${currency_symbol()})`,
                                                                    id: 'amount',
                                                                    width: 150,
                                                                    filterable: false,
                                                                    accessor: row => {
                                                                        return (
                                                                            <div style={{ textAlign: "center" }}>
                                                                                {currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}
                                                                            </div>
                                                                        );
                                                                    },
                                                                    Footer: (props) => {
                                                                        const { data } = props;
                                                                        const tempList = (data).map(d => d._original);
                                                                        const _sum = tempList.reduce((prev, cur) => numberParce(prev) + numberParce(cur.amount), 0)
                                                                        return <div style={{ textAlign: "center" }}>{currency_symbol() + ' ' + (_sum).toFixed(2)}</div>
                                                                    }
                                                                },
                                                                {
                                                                    Header: "Description",
                                                                    accessor: "transactionDesc",
                                                                    style: { textAlign: 'center' },
                                                                    filterable: false
                                                                }, {
                                                                    Header: 'Action',
                                                                    id: 'action',
                                                                    filterable: false,
                                                                    style: { textAlign: 'center' },
                                                                    minWidth: 50,
                                                                    Cell: row => {
                                                                        return (
                                                                            <a title="Delete Transaction" onClick={() => {
                                                                                const id = row.original.idNumb || 0;
                                                                                this.setState({ deletePurchaseModel: true, deletePurchaseId: id })
                                                                            }}><b><i className="fa tbl-rounded-icon fa-icon fa-trash bg-color-3"></i></b></a>
                                                                        )
                                                                    }
                                                                }
                                                            ]} data={_.orderBy(this.state.purchaseData, ['studentLName', 'studentFName'], ['asc'])} defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'EventPayments' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section6">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Event Purchases</h3>

                                                    <div style={{
                                                        display: 'inline-block',
                                                        backgroundColor: 'transparent',
                                                        marginTop: '-7px',
                                                        float: 'right',
                                                        borderRadius: '3px'
                                                    }}>
                                                        <div className="btn-group">
                                                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                        onClick={() => { this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, true); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                </li>
                                                                <li>
                                                                    <TmExportExcel id="eventReport"
                                                                        name={"Event Purchases Report"}
                                                                        filename={"Event Purchases Report"}
                                                                        element={<a title="Click to Download Excel" id="eventReport"
                                                                            style={{
                                                                                display: 'block',
                                                                                padding: '3px 20px',
                                                                                clear: 'both',
                                                                                fontWeight: '400',
                                                                                lineHeight: 1.42857143,
                                                                                color: '#333',
                                                                                whiteSpace: 'nowrap',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                                        dataSet={this.buildEventPaymentReportFormatForExport()}
                                                                    />
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="panel-body">
                                                    <div className='row' style={{ marginTop: '5px', marginBottom: '5px', fontSize: '16px' }}>
                                                        <div className='col-md-2'>
                                                            <label>Select date range:</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <DateTimeRangePicker
                                                                startDate={this.state.selectedDates.startDate}
                                                                endDate={this.state.selectedDates.endDate}
                                                                isReport={false}
                                                                applyCallback={(event, picker) => {
                                                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                                                }}
                                                                isDateShow={true} />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <ReactTable className="-striped -highlight" {...checkboxProps}
                                                                filterable
                                                                columns={[
                                                                    {
                                                                        Header: "Event Name",
                                                                        accessor: "eventName",
                                                                        style: { textAlign: 'center' },
                                                                        filterMethod: (filter, row) => {
                                                                            return (row._original.eventName.toLowerCase().startsWith(filter.value.toLowerCase()))
                                                                        },
                                                                        Footer: <div style={{ textAlign: "center" }}>Total :</div>
                                                                    },
                                                                    {
                                                                        Header: "Total Amount ($)",
                                                                        accessor: "totalAmt",
                                                                        style: { textAlign: 'center' },
                                                                        width: 150,
                                                                        Cell: row => <span>{row.value.toFixed(2)}</span>,
                                                                        Footer: <div style={{ textAlign: "center" }}>$ {(_.sum(_.map(this.state.eventsPayments, d => d.totalAmt))).toFixed(2)}</div>
                                                                    }
                                                                ]} data={this.state.eventsPayments || []}
                                                                defaultPageSize={10} minRows={0}
                                                                SubComponent={(row) => {
                                                                    return (
                                                                        <ReactTable filterable className="-striped -highlight" {...checkboxProps}
                                                                            columns={[
                                                                                {
                                                                                    Header: "Name",
                                                                                    accessor: "fullName",
                                                                                    filterMethod: (filter, row) => {
                                                                                        return (row._original.fullName.toLowerCase().startsWith(filter.value.toLowerCase()))
                                                                                    }
                                                                                },
                                                                                {
                                                                                    Header: 'Transaction Date',
                                                                                    accessor: 'trxDateTime',
                                                                                    width: 200
                                                                                },
                                                                                {
                                                                                    Header: "Amount ($)",
                                                                                    accessor: 'transactionAmount',
                                                                                    style: { textAlign: 'right' },
                                                                                    width: 150,
                                                                                    Cell: row => <span>{row.value.toFixed(2)}</span>
                                                                                }
                                                                            ]}
                                                                            data={row.original.students || []}
                                                                            defaultPageSize={10} minRows={0} />
                                                                    )
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'BCACPayments' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section7">
                                            <BcacPayments ref={this.bcacChild} gradeList={gradeList} {...this.props} />
                                        </div>
                                    )}
                                    {reportName === 'DailyRevenue' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section8">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title">Daily Reports</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <div className="col-md-offset-3 col-md-6">
                                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                            <label className="custom-label col-md-3 text-right" style={{ margin: '10px 0px' }}> Date</label>
                                                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                                <Datetime ref='startCalendar' dateFormat={'YYYY/MM/DD'} timeFormat={false}
                                                                    closeOnSelect={true} value={this.state.startDate}
                                                                    onChange={(e) => {
                                                                        this.setState({ startDate: moment(e) })
                                                                        this.refs.startCalendar.closeCalendar()
                                                                    }} renderInput={this.renderInput} />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3"></div>
                                                            <div className="col-md-6 text-center">
                                                                <button className="btn btn-success btn-sm pull-right" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.downloadReport(1);
                                                                }}> Download Report
                                                                </button>
                                                            </div>
                                                            <div className="col-md-3"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                    {reportName === 'MonthlyRevenue' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section8">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title">Monthly Reports</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <div className="col-md-offset-3 col-md-6">
                                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                                <label className="custom-label col-md-3 text-right" style={{ margin: '10px 0px' }}>Month</label>
                                                                <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                                    <Datetime inputProps={{ placeholder: 'Select Month' }}
                                                                        ref='calendar'
                                                                        dateFormat="MMMM YYYY"
                                                                        timeFormat={false}
                                                                        selected={this.state.date}
                                                                        closeOnSelect={true} isValidDate={valid}
                                                                        onChange={this.setDate}
                                                                        renderInput={this.renderInput}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3"></div>
                                                            <div className="col-md-6 text-center">
                                                                <button className="btn btn-success btn-sm pull-right" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.downloadReport(7);
                                                                }}> Download Report
                                                                </button>
                                                            </div>
                                                            <div className="col-md-3"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                    {reportName === 'MonthlyIncome' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section9">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title"> Monthly Income Report </h3>
                                                </div>
                                                <div className="panel-body">
                                                    <div className="col-md-offset-2 col-md-7">
                                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                            <label className="custom-label col-md-4 text-center" style={{ margin: '18px -18px' }}>Report for</label>
                                                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                                <div className="row">

                                                                    <div className="styled-input-single col-md-3">
                                                                        <input type="radio" name="mealType" id={'rb' + enumMealType.lunch} onChange={() => {
                                                                            this.setState({ mealType: enumMealType.lunch })
                                                                        }} checked={this.state.mealType === enumMealType.lunch} />
                                                                        <label htmlFor={'rb' + enumMealType.lunch}>{enumMealType.lunch}</label>
                                                                    </div>
                                                                    <div className="styled-input-single col-md-3 pr-1" style={{ marginLeft: '-3px' }}>
                                                                        <input type="radio" name="mealType" id={'rb' + enumMealType.breakfast} onChange={() => {
                                                                            this.setState({ mealType: enumMealType.breakfast })
                                                                        }} checked={this.state.mealType === enumMealType.breakfast} />
                                                                        <label htmlFor={'rb' + enumMealType.breakfast}>{enumMealType.breakfast}</label>
                                                                    </div>


                                                                    <div className="styled-input-single col-md-3" style={{ marginLeft: '3px' }}>
                                                                        <input type="radio" name="mealType" id={'rb' + enumMealType.snack} onChange={() => {
                                                                            this.setState({ mealType: enumMealType.snack })
                                                                        }} checked={this.state.mealType === enumMealType.snack} />
                                                                        <label htmlFor={'rb' + enumMealType.snack}>{enumMealType.snack}</label>
                                                                    </div>
                                                                    <div className="styled-input-single col-md-3">
                                                                        <input type="radio" name="mealType" id={'rb' + enumMealType.dinner} onChange={() => {
                                                                            this.setState({ mealType: enumMealType.dinner })
                                                                        }} checked={this.state.mealType === enumMealType.dinner} />
                                                                        <label htmlFor={'rb' + enumMealType.dinner}>{enumMealType.dinner}</label>
                                                                    </div>




                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                                            <label className="custom-label col-md-3 text-right" style={{ margin: '10px 0px' }}>Month</label>
                                                            <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                                                <Datetime inputProps={{ placeholder: 'Select Month' }}
                                                                    ref='calendar'
                                                                    dateFormat="MMMM YYYY"
                                                                    timeFormat={false}
                                                                    selected={this.state.date}
                                                                    closeOnSelect={true} isValidDate={valid}
                                                                    onChange={this.setDate}
                                                                    renderInput={this.renderInput}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3"></div>
                                                            <div className="col-md-5">
                                                                <button className="btn btn-success btn-sm pull-right" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.downloadReport(4);
                                                                }}> Download Report
                                                                </button>
                                                            </div>
                                                            <div className="col-md-4"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'IncomebyGrade' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section10">
                                            <OrderCost />
                                        </div>
                                    )}
                                    {reportName === 'Adjustments' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Section11">
                                            <AdjustmentReport ref='adjCtrl' />
                                        </div>
                                    )}
                                    {reportName === 'Sales' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="SectionSale">
                                            <SalesReport />
                                        </div>
                                    )}
                                    {reportName === 'SalesTaxReport' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="SectionSaleTax">
                                            <SalesTaxReport ref='stCtrl' />
                                        </div>
                                    )}
                                    {reportName === 'Donations' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="donationReports">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Donation Report</h3>

                                                    <div style={{
                                                        display: 'inline-block',
                                                        backgroundColor: 'transparent',
                                                        marginTop: '-7px',
                                                        float: 'right',
                                                        borderRadius: '3px'
                                                    }}>
                                                        <div className="btn-group">
                                                            <button className="btn-link btn-sm dropdown-toggle" type="button"
                                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                                                <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                                                        onClick={() => { this.getData(this.state.selectedDates.startDate, this.state.selectedDates.endDate, true); }}
                                                                        target='_blank'
                                                                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                                                </li>
                                                                <li>
                                                                    <TmExportExcel id="donationsReport"
                                                                        name={"Donations report"}
                                                                        filename={"Donations report"}
                                                                        element={<a title="Click to Download Excel" id="donationsReport"
                                                                            style={{
                                                                                display: 'block',
                                                                                padding: '3px 20px',
                                                                                clear: 'both',
                                                                                fontWeight: '400',
                                                                                lineHeight: 1.42857143,
                                                                                color: '#333',
                                                                                whiteSpace: 'nowrap',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                                                                        dataSet={this.buildDonationsReportFormatForExport()}
                                                                    />
                                                                </li>

                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="panel-body">
                                                    <div className='row' style={{ marginTop: '5px', marginBottom: '5px', fontSize: '16px' }}>
                                                        <div className='col-md-2'>
                                                            <label>Select date range:</label>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <DateTimeRangePicker
                                                                startDate={this.state.selectedDates.startDate}
                                                                endDate={this.state.selectedDates.endDate}
                                                                isReport={false}
                                                                applyCallback={(event, picker) => {
                                                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                                                }}
                                                                isDateShow={true} />
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-12">
                                                            <ReactTable
                                                                filterable
                                                                columns={[
                                                                    {
                                                                        Header: "Student First Name",
                                                                        id: "studentFName",
                                                                        width: 200,
                                                                        style: { textAlign: 'center' },
                                                                        accessor: 'studentFName',
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row.studentFName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                                                        },
                                                                    },
                                                                    {
                                                                        Header: "Student Last Name",
                                                                        id: "studentLName",
                                                                        width: 200,
                                                                        style: { textAlign: 'center' },
                                                                        accessor: 'studentLName',
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row.studentLName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                                                        },
                                                                    },
                                                                    {
                                                                        Header: "Parent Email ID",
                                                                        accessor: "user",
                                                                        width: 200,
                                                                        style: { textAlign: 'center' },
                                                                        Cell: row => (<span style={{ textAlign: 'center', width: "200px" }}>{row.original.user}</span>),
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                        },
                                                                    },
                                                                    {
                                                                        Header: "Date",
                                                                        filterable: false,
                                                                        accessor: "transactionDate",
                                                                        style: { textAlign: 'center' },
                                                                        //Cell: row => (<span style={{ textAlign: 'center' }}>{row.original.transactionDate}</span>)
                                                                    },
                                                                    {
                                                                        Header: "Time",
                                                                        filterable: false,
                                                                        accessor: "transactionTime",
                                                                        style: { textAlign: 'center' },
                                                                        //Cell: row => (<span style={{ textAlign: 'center' }}>{row.original.transactionTime}</span>)
                                                                    },
                                                                    {
                                                                        Header: "Type",
                                                                        accessor: "paymentType",
                                                                        style: { textAlign: 'center' },
                                                                        filterMethod: (filter, row) => {
                                                                            const _row = row._original
                                                                            return (_row['paymentType']).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                        },
                                                                        Filter: ({ filter, onChange }) => {
                                                                            return (
                                                                                <select className="form-control"
                                                                                    onChange={event => onChange(event.target.value)}
                                                                                    value={filter ? filter.value : 'all'}
                                                                                >
                                                                                    <option value={''}>{''}</option>
                                                                                    {_.map(
                                                                                        _.uniq(
                                                                                            _.map(this.state.donationsReport, function (obj) {
                                                                                                return obj.paymentType;
                                                                                            })
                                                                                        )).map(item =>
                                                                                            <option value={item}>{item}</option>
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                            )
                                                                        },
                                                                    },
                                                                    {
                                                                        Header: `Amount Donated (${currency_symbol()})`,
                                                                        accessor: "amount",
                                                                        width: 170,
                                                                        style: { textAlign: 'center' },
                                                                        filterable: false,
                                                                        Cell: row => (<span style={{ textAlign: 'center', width: "170px" }}>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.original.amount)}</span>)
                                                                    },
                                                                    {
                                                                        Header: "Meals Donated",
                                                                        accessor: "donationMealCount",
                                                                        style: { textAlign: 'center' },
                                                                        filterable: false,
                                                                        //Cell: row => (<span style={{ textAlign: 'center' }}>{row.original.donationMealCount}</span>)
                                                                    }

                                                                ]} data={this.state.donationsReport} defaultPageSize={10} className="-striped -highlight" />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'DonationMatchReport' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="donationMatchReport">
                                            <DonationPartnerReport ref='dprCtrl' />
                                        </div>
                                    )}
                                    {reportName === 'BulkPurchases' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="bulkPurchasesReport">
                                            <BulkPurchases ref='bprCtrl' />
                                        </div>
                                    )}
                                    {reportName === 'MonthlyIncomeCash' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="monthlyIncomeCash">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title" style={{ display: 'inline' }}>Monthly Cash Income Report</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <div className='row'>
                                                        <div className='col-md-4 col-md-offset-4'>
                                                            <MonthlyIncomeCash {...this} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {reportName === 'StripeReconciliationreport' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="stripeReconciliationreport">
                                            <StripeReconciliationreport {...this} />
                                        </div>
                                    )}
                                    {reportName === 'ItemSalesSummary' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="dailySalesReport">
                                            <DailySalesReport {...this} />
                                        </div>
                                    )}
                                    {reportName === 'Consumption_paymentsReport' && (
                                        <div role="tabpanel" className={`tab-pane active`} id="Consumption_paymentsReport">
                                            <div><ConsumptionPaymentReport  {...this} /></div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.showDelDepModal}
                    onRequestClose={() => this.setState({ showDelDepModal: false })}
                    style={modalStyles.customManageUsersStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Delete Deposit confirmation</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to delete record?</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.setState({ showDelDepModal: false, deleteDepRecId: 0 })}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                        </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={() => {
                                this.deleteDepositRecord(this.state.deleteDepRecId);
                            }}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                        </button>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.deletePurchaseModel}
                    onRequestClose={() => this.setState({ deletePurchaseModel: false, deletePurchaseId: 0 })}
                    style={deleteStyles}
                    contentLabel="Publish">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Deleting a Transaction</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to continue?</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.setState({ deletePurchaseModel: false, deletePurchaseId: 0 })}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> No
                        </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={this.deletePurchaseRec}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                        </button>
                    </div>
                </Modal>
            </section>
        </div>);
    }

}
ReportTable.contextTypes = { router: PropTypes.object.isRequired }
export default ReportTable;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/reportTable.jsx